__turbopack_context__.v({
  "buyCanadianWrapper": "ProductSlider-module-scss-module__Xy9cKW__buyCanadianWrapper",
  "fadeLeft": "ProductSlider-module-scss-module__Xy9cKW__fadeLeft",
  "fadeLeftHide": "ProductSlider-module-scss-module__Xy9cKW__fadeLeftHide",
  "fadeRight": "ProductSlider-module-scss-module__Xy9cKW__fadeRight",
  "fadeRightHide": "ProductSlider-module-scss-module__Xy9cKW__fadeRightHide",
  "mainImage": "ProductSlider-module-scss-module__Xy9cKW__mainImage",
  "mainImageOverlay": "ProductSlider-module-scss-module__Xy9cKW__mainImageOverlay",
  "mainImageOverlayText": "ProductSlider-module-scss-module__Xy9cKW__mainImageOverlayText",
  "overlay": "ProductSlider-module-scss-module__Xy9cKW__overlay",
  "overlayText": "ProductSlider-module-scss-module__Xy9cKW__overlayText",
  "screenReaderOnly": "ProductSlider-module-scss-module__Xy9cKW__screenReaderOnly",
  "swipeButtHide": "ProductSlider-module-scss-module__Xy9cKW__swipeButtHide",
  "swipeButtNext": "ProductSlider-module-scss-module__Xy9cKW__swipeButtNext",
  "swipeButtPrev": "ProductSlider-module-scss-module__Xy9cKW__swipeButtPrev",
  "swiper": "ProductSlider-module-scss-module__Xy9cKW__swiper",
  "thumbSlide": "ProductSlider-module-scss-module__Xy9cKW__thumbSlide",
  "thumbSlideActive": "ProductSlider-module-scss-module__Xy9cKW__thumbSlideActive",
  "thumbSlideOverlay": "ProductSlider-module-scss-module__Xy9cKW__thumbSlideOverlay",
  "thumbSlideOverlayText": "ProductSlider-module-scss-module__Xy9cKW__thumbSlideOverlayText",
  "thumbSlideVideo": "ProductSlider-module-scss-module__Xy9cKW__thumbSlideVideo",
  "thumbWrapper": "ProductSlider-module-scss-module__Xy9cKW__thumbWrapper",
  "videoIcon": "ProductSlider-module-scss-module__Xy9cKW__videoIcon",
  "videoWrapper": "ProductSlider-module-scss-module__Xy9cKW__videoWrapper",
});
